export default {
  assistant: {
    error: "He encontrado un problema técnico al procesar tu mensaje. Por favor, inténtalo de nuevo más tarde.",
    inputPlaceholder: "Escribe tu mensaje...",
    title: "Asistente de IA",
    welcome: "¡Hola! Soy su asistente digital de viajes. Estoy aquí para hacer su viaje más agradable ayudándole con sus planes e itinerarios. No dude en enviarme los detalles de sus viajes, aún no tengo acceso a ellos. ¿En qué puedo ayudarle hoy? 😊"
  },
  common: {
    save: "Guardar cambios",
    cancel: "Cancelar",
    saving: "Guardando...",
    updating: "Actualizando...",
    back: "Atrás",
    comingSoon: "Más funciones próximamente",
    error:"Error",
    success: "Éxito",
    in: "en",
    toast: {
      success: "¡Éxito!",
      error: "Error",
      info: "Información",
      warning: "Advertencia",
      copied: "Copiado al portapapeles",
      saved: "Cambios guardados",
      deleted: "Eliminado con éxito",
      updated: "Actualizado con éxito"
    }
  },
  auth: {
    signOut: "Cerrar sesión",
    signOutSuccess: "Sesión cerrada con éxito",
    redirectingHome: "Redirigiendo a la página principal...",
    loginWithEmail: "Iniciar sesión con correo electrónico",
    createAccount: "Crear cuenta",
    welcomeBack: "Bienvenido de nuevo",
    enterEmailForCode: "Ingrese su correo electrónico para recibir un código de un solo uso",
    signUpToManageTrips: "Regístrese para comenzar a gestionar sus viajes",
    signInToAccessTrips: "Inicie sesión para acceder a sus viajes",
    passwordValidation: "La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número, un carácter especial y debe tener entre 8 y 15 caracteres.",
    password: "Contraseña",
    otpLogin: "Email login",
    register: "Registrarse",
    emailConfirmationRequired: "Confirmación de correo electrónico requerida",
    checkEmailForConfirmation: "Por favor, revise su bandeja de entrada para un enlace de confirmación. Debe confirmar su dirección de correo electrónico antes de continuar.",
    invalidEmail: "Por favor, ingrese una dirección de correo electrónico válida",
    confirmEmail: "Confirmar correo electrónico",
    emailMismatch: "Las direcciones de correo electrónico no coinciden",
    verificationEmailSent: "Por favor, revise sus correos electrónicos para encontrar un código de verificación.",
    incorrectVerificationCode: "El código de verificación es incorrecto",
    loginSuccess: "¡Inicio de sesión exitoso!",
    registrationPasswordSuccess: "¡Registro exitoso y contraseña guardada!",
    incorrectCredentials: "Las credenciales son incorrectas",
    otpRequestFailed: "Error al solicitar el código OTP",
    unexpectedError: "Ocurrió un error inesperado",
    codeSent: "Código enviado",
    checkEmailForCode: "Por favor, revise su correo electrónico para ver el código de verificación.",
    sessionCreationFailed: "Error al crear la sesión",
    enterVerificationCode: "Ingrese el código de verificación enviado a",
    enter6DigitCode: "Ingrese el código de 6 dígitos",
    optionalPassword: "Opcionalmente puede establecer una contraseña para su cuenta",
    passwordOptional: "Contraseña (Opcional)",
    confirmPassword: "Confirmar contraseña",
    registrationComplete: "¡Registro completo!",
    accountCreatedRedirect: "Su cuenta ha sido creada con éxito. Será redirigido en breve...",
    validateEmail: "Validar su correo electrónico",
    signIn: "Iniciar sesión",
    sending: "Enviando...",
    verifyEmail: "Verificar correo electrónico",
    backToEmail: "Volver al correo electrónico",
    verifying: "Verificando...",
    validateOTP: "Validar OTP",
    noAccount: "¿No tiene una cuenta? Regístrese",
    travelAppLogo: "Aplicación de viajes",
    forgotPassword: "¿Olvidó su contraseña?",
    forgotPasswordInstructions: "Por favor, inicie sesión con su correo electrónico y luego cambie su contraseña",
    firstName: "Nombre",
    lastName: "Apellido",
    emailAddress: "Correo electrónico",
    confirmEmailAddress: "Confirmar correo electrónico",
    termsAgreementPart1: "Al crear su cuenta, acepta nuestros",
    termsOfService: "Términos de servicio",
    privacyPolicy: "Política de privacidad",
    adtdTripPWaiting: "Tu viaje está listo para ser importado",
    adtdTripPWaitingDescription: "Por favor, inicia sesión en tu cuenta o crea una para continuar. Nos aseguraremos de que la reserva coincida con tu identidad.",
    loginDescription: "Rastree vuelos, organice sus viajes y acceda a toda su información de viaje. Todo lo que necesita para un viaje sin contratiempos, en un solo lugar.",
    loginAppDescription: "Toda tu información de viaje en un solo lugar"
  },
  settings: {
    title: "Configuración",
    profile: {
      title: "Mi perfil",
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Correo electrónico",
      country: "País",
      city: "Ciudad",
      selectCountry: "Seleccione o escriba un país",
      enterCity: "Ingrese su ciudad"
    },
    language: {
      title: "Idioma",
      preferred: "Idioma preferido",
    },
    currency: {
      title: "Moneda",
      preferred: "Moneda preferida"
    },
    notifications: {
      title: "Notificaciones",
      emailNotifications: "Notificaciones por correo electrónico",
      description: "Recibir notificaciones por correo electrónico sobre actualizaciones importantes",
    },
    consent: {
      title: "Gestión de consentimiento",
      open: "Abrir gestor de consentimiento",
      description: "Administre sus preferencias de privacidad y cookies"
    },
    about: {
      title: "Acerca de nosotros",
      tos: "Términos de servicio",
      privacy: "Política de privacidad",
      faq: "Preguntas frecuentes",
    },
    contact: {
      title: "Contáctenos",
      email: "feedback@checkmytrip.com",
    },
    social: {
      title: "Encuéntrenos en redes sociales",
    },
    deleteAccount: "Eliminar cuenta",
    deleteAccountDescription: "Eliminar permanentemente su cuenta y todos los datos asociados",
    confirmDelete: "¿Está seguro?",
    deleteWarning: "Esta acción no se puede deshacer. Esto eliminará permanentemente su cuenta y todos sus datos de nuestros servidores.",
    confirmDeleteButton: "Sí, eliminar mi cuenta",
    accountDeleted: "Su cuenta ha sido eliminada con éxito.",
    deleteError: "Error al eliminar la cuenta",
    profileUpdated: "Perfil actualizado con éxito",
    updateError: "Error al actualizar el perfil",
    passwordMismatch: "Las contraseñas no coinciden",
    passwordTooShort: "La contraseña debe tener al menos 8 caracteres",
    passwordUpdated: "Contraseña actualizada con éxito",
    changePassword: "Cambiar contraseña",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    updatePassword: "Actualizar contraseña",
    feedback: {
      title: "Comentarios",
      description: "Valoramos sus comentarios. Ayúdenos a mejorar nuestro servicio compartiendo sus opiniones.",
      button: "Dar opinión"
    }
  },
  index: {
    greeting: "Hola, Viajero",
    greetingWithName: "Hola, {{name}}",
    manageTrips: "Gestione sus viajes",
    bookingRef: "Referencia de reserva",
    lastName: "Apellido",
    addTrip: "Añadir viaje",
    timeline: "Su línea de tiempo",
    welcome: {
      title: "Bienvenido a su aplicación de viajes",
      ready: "¿Está listo para gestionar sus viajes de manera más inteligente?",
      features: {
        tripManagement: {
          title: "Gestión de viajes",
          description: "Mantenga todos sus detalles de viaje en un solo lugar - vuelos, hoteles y actividades."
        },
        tripAlerts: {
          title: "Alertas de viaje",
          description: "Reciba notificaciones oportunas sobre sus vuelos, cambios de puerta y actualizaciones importantes de viaje."
        },
        inspiration: {
          title: "Inspiración para viajes",
          description: "Descubre nuevos destinos y recibe recomendaciones personalizadas para tus aventuras"
        },
        offers: {
          title: "Ofertas y descuentos",
          description: "Acceda a ofertas exclusivas y ahorre en sus próximos viajes."
        }
      },
      getStarted: "Consejos rápidos para comenzar",
      tips: {
        profile: "Complete su perfil para una experiencia personalizada",
        addTrip: "Añada su primer viaje haciendo clic en el botón 'Nuevo Viaje'",
        dates: "Mantén un seguimiento de las fechas importantes de tu viaje en el calendario",
        notifications: "Active las notificaciones para mantenerse informado sobre tus viajes"
      }
    },
    importAdtdTripSuccess: "Viaje importado con éxito",
    importAdtdTripError: "No se pudo importar el viaje a esta cuenta",
    checkYourTrips: "Revisa tus viajes en la aplicación"
  },
  tripCard: {
    daysLeft: "días",
    flightDetails: "Detalles del vuelo",
    terminal: "Terminal",
    gate: "Puerta",
    checkIn: "Facturación",
    checkStatus: "Verificar estado",
    flightInfo: "Información del vuelo",
    airline: "Aerolínea",
    flight: "Vuelo",
    departure: "Salida",
    arrival: "Llegada",
    getFlightDetails: "Detalles del vuelo",
    destinationInfo: "Info del destino",
    weather: "Clima",
    activities: "Actividades recomendadas",
    food: "Restaurantes y cafés",
    today: "Hoy",
    dayAgo: "Hace 1 día",
    daysAgo: "Hace {{count}} días",
    remainingDay: "1 día restante",
    remainingDays: "{{count}} días restantes",
    tripStatus: {
      ongoing: "Viaje en curso",
      upcoming: "Próximo viaje",
      past: "Viaje pasado"
    },
    hotel: "Hotel",
    car: "Coche",
    activity: "Actividad",
    viewOnMap: "Ver en mapa",
    direct: "Directo",
    addToCalendar: "Añadir al calendario",
    tripInfo: "Información del viaje",
    destination: "Destino",
    noFlightInfoFound: "No se encontró información de vuelo",
    noFlightStatusAvailable: "No hay información de estado de vuelo disponible",
    flightStatus: "Estado del vuelo",
    flightInfoUpdated: "Información de vuelo actualizada",
    failedFlightStatus: "Error al verificar el estado del vuelo. Por favor, inténtelo de nuevo.",
    tripDetails: "Detalles del viaje",
    deleteTrip: "Eliminar viaje",
    confirmDelete: "¿Eliminar viaje?",
    deleteWarning: "Esta acción no se puede deshacer. Esto eliminará permanentemente su viaje a {{tripName}} y lo eliminará de su cuenta.",
    confirmDeleteButton: "Sí, eliminar viaje",
    tripDeleted: "El viaje ha sido eliminado con éxito.",
    deleteError: "Error al eliminar el viaje",
    economy: "Económica",
    business: "Negocios",
    first: "Primera",
    premiumEconomy: "Económica Premium",
    carRental: "Alquiler de coche",
    carModel: "Modelo de coche",
    pickupLocation: "Lugar de recogida",
    dropoffLocation: "Lugar de devolución",
    pickup: "Recogida",
    dropoff: "Devolución",
    confirmationNumber: "Número de confirmación",
    notifications: "Notificaciones",
    notificationsDescription: "Notificaciones importantes sobre tus viajes",
    noNotifications: "No hay notificaciones todavía",
    notificationsOnMobile: "Esta función solo está disponible en la aplicación móvil por el momento",
    taxiTransfer: "Reservar un viaje",
    taxiTransferDesc: "Reserva un traslado en taxi a tu hotel o aeropuerto",
    taxiTransferComingSoon: "Traslado en taxi próximamente",
    loadingNotifications: "Cargando notificaciones..."
  },
  newTrip: {
    title: "Añadir un nuevo viaje",
    bookingReference: "Referencia de reserva",
    bookingReferenceDesc: "Ingrese su referencia de reserva de 6 caracteres y asegúrese de que el nombre y apellido en su perfil sean los mismos que en su reserva.",
    bookingRefPlaceholder: "Referencia (ej. ABC123)",
    bookingRefTooShort: "La referencia de reserva debe tener al menos 6 caracteres",
    bookingRefTooLong: "La referencia de reserva puede tener como máximo 10 caracteres",
    lastNamePlaceholder: "Apellido",
    findBooking: "Buscar reserva",
    gmailSync: "Sincronizar con Gmail",
    gmailSyncDesc: "Permítenos escanear tu bandeja de entrada de Gmail para buscar reservas de viaje",
    connectGmail: "Conectar cuenta de Gmail",
    emailForward: "Reenviar correo de reserva",
    emailForwardDesc: "Reenvía tu correo de confirmación de reserva para añadir tu viaje",
    emailCopied: "Dirección de correo copiada",
    emailCopiedDesc: "La dirección de correo ha sido copiada al portapapeles",
    copyEmail: "Copiar dirección de correo",
    manual: "Entrada manual",
    manualDesc: "Añadir los detalles de tu viaje manualmente",
    startManual: "Iniciar entrada manual",
    bookingSubmitted: "Reserva enviada",
    processingBooking: "Estamos buscando tu reserva...",
    gmailConsent: "Conexión Gmail",
    gmailProcessing: "Conectando a tu cuenta de Gmail...",
    manualEntry: "Entrada manual de viaje",
    manualEntryDesc: "Crea un viaje añadiendo tú mismo los detalles de vuelos y hoteles",
    drawer: {
      addTripDetails: "Añadir detalles del viaje",
      tripInfo: "Información del viaje",
      tripName: "Nombre del viaje",
      tripType: "Tipo de viaje",
      selectTripType: "Seleccionar tipo de viaje",
      leisure: "Ocio",
      business: "Negocios",
      family: "Familia",
      bleisure: "Ocio y negocios",
      travelers: "Número de viajeros",
      addFlight: "Añadir vuelo",
      flightNumber: "Número de vuelo (ej. IB1234)",
      departureDate: "Fecha de salida",
      addedFlights: "Vuelos añadidos",
      from: "Desde:",
      to: "Hacia:",
      terminal: "Terminal:",
      departure: "Salida:",
      arrival: "Llegada:",
      addHotel: "Añadir hotel",
      hotelName: "Nombre del hotel",
      cityName: "Nombre de la ciudad",
      selectCheckInOut: "Seleccionar fechas de entrada/salida",
      addedHotels: "Hoteles añadidos",
      createTrip: "Crear viaje",
      adding: "Añadiendo...",
      selectFlight: "Seleccionar vuelo",
      confirmFlight: "Confirmar vuelo",
      step1: "Info",
      step2: "Vuelos",
      step3: "Hoteles",
      step4: "Revisión",
      next: "Siguiente",
      back: "Atrás",
      review: "Revisar",
      flightsStepEmpty: "Añade al menos un vuelo a tu viaje",
      flightsStepWithFlights: "Has añadido {{count}} vuelo(s)",
      hotelsStepEmpty: "Añade hoteles a tu viaje (opcional)",
      hotelsStepWithHotels: "Has añadido {{count}} hotel(es)",
      reviewTrip: "Revisar tu viaje",
      reviewDescription: "Verifica los detalles de tu viaje antes de crearlo",
      tripSummary: "Resumen del viaje",
      flightsSummary: "Vuelos",
      hotelsSummary: "Hoteles"
    },
    profileMismatch: "Lo sentimos, la información de tu perfil no coincide con la reserva. Por favor, dirígete a Perfil y asegúrate de que tu nombre y apellido sean los mismos que se usaron para hacer la reserva. También puedes intentar importar tu viaje con las siguientes opciones a continuación reenviando tu correo electrónico de confirmación de reserva o ingresando el viaje manualmente.",
    loginDescription: "Rastree vuelos, organice sus viajes y acceda a toda su información de viaje. Todo lo que necesita para un viaje sin contratiempos, en un solo lugar."
  },
  discover: {
    title: "Descubrir Experiencias",
    subtitle: "Encuentre y explore actividades para su próxima aventura",
    getInspired: "Inspírese",
    searchFilters: "Filtros de búsqueda",
    search: "Buscar",
    city: "Ciudad",
    enterCityName: "Ingrese nombre de ciudad",
    priceRange: "Rango de precio",
    min: "Mínimo",
    max: "Máximo",
    radius: "Radio (km)",
    enterRadius: "Ingrese radio",
    searchButton: "Buscar",
    categoryTypes: "Categorías",
    popularActivities: "Actividades populares",
    searchPlaceholder: "Buscar actividades, lugares o experiencias...",
    allActivities: "Todas las actividades",
    inspiration: {
      location: "Ubicación",
      price: "Rango de precio",
      bestTimeToVisit: "Mejor época para visitar",
      howToGetThere: "Cómo llegar allí"
    },
    categories: {
      tour: "Tour",
      adventure: "Aventura",
      food: "Comida y Bebida",
      culture: "Cultura",
      sightseeing: "Turismo",
      entertainment: "Entretenimiento",
      nature: "Naturaleza",
      wellness: "Bienestar",
      sport: "Deporte",
      workshop: "Taller"
    }
  },
  sidebar: {
    assistant: "Asistente",
    myTrips: "Mis Viajes",
    discover: "Descubrir",
    newTrip: "Nuevo Viaje",
    profile: "Perfil",
    feedback: "Comentarios"
  },
  weather: {
    in: "Clima en",
    loading: "Cargando datos del clima...",
    currentWeather: "Clima actual",
    forecast: "Pronóstico",
    temperature: "Temperatura",
    feelsLike: "Sensación térmica",
    wind: "Viento",
    humidity: "Humedad",
    precipitation: "Precipitación",
    pressure: "Presión",
    visibility: "Visibilidad",
    uvIndex: "Índice UV",
    sunrise: "Amanecer",
    sunset: "Atardecer",
    daily: "Diario",
    hourly: "Por hora",
    today: "Hoy",
    tomorrow: "Mañana",
    min: "Mín",
    max: "Máx"
  },
  errors: {
    configurationError: "Error de configuración",
    websiteNotConfigured: "El sitio web no está configurado correctamente."
  }
}
